import { useTranslate } from '@festina-life/ui/hooks'
import { paperStyles } from '@festina-life/ui/libs'
import { Stack } from '@festina-life/ui/structure'
import cx from 'classnames'

import { TemplateNavigationButton } from './TemplateNavigationButton'
import { CONFIGURATION_VIEWER_ID } from './templateViewer/TemplateCentralView'

export const PREVIOUS_DIFF_TYPE = 'previous-diff'
export const INHERITANCE_DIFF_TYPE = 'inheritance-diff'
export const ERROR_TYPE = 'error-row'

export const TemplateNavigationControls = () => {
  const translate = useTranslate()

  const scrollToNextElementOfId = (id: string) => {
    const currentTemplateViewerElement = document.getElementById(
      CONFIGURATION_VIEWER_ID,
    )

    if (!currentTemplateViewerElement) {
      return
    }

    const allElementsOfId = currentTemplateViewerElement
      .querySelectorAll(`[data-type="${id}"]`)
      .values()
      .toArray()
      .filter((element) =>
        element.checkVisibility({ visibilityProperty: true }),
      )

    if (!allElementsOfId.length) {
      return
    }

    const availableElementsAfterCurrentScroll = allElementsOfId.filter(
      (element) =>
        element.getBoundingClientRect().top >
        currentTemplateViewerElement.clientHeight,
    )

    const scrollToElement =
      availableElementsAfterCurrentScroll.at(0) ?? allElementsOfId[0]

    scrollToElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }

  return (
    <Stack className={cx('rounded-lg px-1.5 py-1', paperStyles())}>
      <TemplateNavigationButton
        iconName="ChevronDoubleLeft"
        iconClassName="text-diff-previous dark:text-diff-previousDark"
        onClick={() => scrollToNextElementOfId(PREVIOUS_DIFF_TYPE)}
        tip={translate(
          'templateViewer.topBar.navigationControls.nextPreviousDiff',
        )}
      />
      <TemplateNavigationButton
        iconName="ChevronDoubleUp"
        iconClassName="text-diff-parent dark:text-diff-parentDark"
        onClick={() => scrollToNextElementOfId(INHERITANCE_DIFF_TYPE)}
        tip={translate(
          'templateViewer.topBar.navigationControls.nextInheritanceDiff',
        )}
      />
      <TemplateNavigationButton
        iconName="status.error"
        iconClassName="text-error-400 dark:text-error-900"
        onClick={() => scrollToNextElementOfId(ERROR_TYPE)}
        tip={translate('templateViewer.topBar.navigationControls.nextError')}
      />
    </Stack>
  )
}
